<div class="cell-detail core-screen">
  @if (loading()) {
  <div class="state-message">{{ 'common.loading' | translate }}</div>
  } @else if (error(); as err) {
  <div class="state-message state-message--error">{{ err }}</div>
  } @else if (contents(); as data) {
  <div class="cell-detail__inner">
    <header class="cell-detail__header">
      <h1 class="cell-detail__title">
        {{ 'admin.warehouseCell.title' | translate: { address: cellAddressLabel() } }}
      </h1>
      @if (warehouseBackLink(); as backLink) {
      <a class="cell-detail__breadcrumb" [routerLink]="backLink">
        {{ 'admin.warehouseCell.warehouse' | translate }}: {{ data.warehouse.name }}
      </a>
      }
    </header>

    <section class="section section--actions">
      <lib-not-button
        [text]="'admin.warehouseCell.printQr' | translate"
        [color]="'#0B6270'"
        [bgColor]="'#DCF6F2'"
        [disabled]="printingQr()"
        [action]="{ type: 'action' }"
        (actionEvent)="onPrintQr()"
      />
    </section>

    @if (isEmpty()) {
    <section class="empty-state">
      <h2 class="empty-state__title">
        {{ 'admin.warehouseCell.empty' | translate }}
      </h2>
      <p class="empty-state__hint">
        {{ 'admin.warehouseCell.emptyHint' | translate }}
      </p>
    </section>
    } @else {
    @if (data.boxes.length > 0) {
    <section class="section">
      <h2 class="section__title">
        {{ 'admin.warehouseCell.boxesSection' | translate }}
      </h2>
      <ul class="occupant-list">
        @for (occupant of data.boxes; track occupant.box.id) {
        <li class="occupant-card">
          <div class="occupant-card__head">
            <h3 class="occupant-card__title">
              {{ 'admin.staffQrScan.kindBox' | translate }}
            </h3>
            <p class="occupant-card__id mono">{{ occupant.box.id }}</p>
          </div>
          <dl class="kv">
            <dt>{{ 'admin.warehouseCell.status' | translate }}</dt>
            <dd>{{ storageStatusLabel(occupant.box.status) }}</dd>
            <dt>{{ 'admin.warehouseCell.owner' | translate }}</dt>
            <dd>
              <a
                class="owner-link"
                [routerLink]="ownerProfileLink(occupant.owner.user_id)"
              >
                {{ ownerContactLine(occupant.owner) }}
              </a>
            </dd>
          </dl>
          <div class="occupant-card__items">
            <h4 class="occupant-card__items-title">
              {{ 'admin.warehouseCell.itemsInBox' | translate }}
            </h4>
            @if (occupant.items.length === 0) {
            <p class="muted">
              {{ 'admin.warehouseCell.noItemsInBox' | translate }}
            </p>
            } @else {
            <ul class="item-list">
              @for (item of occupant.items; track item.id) {
              <li class="item-list__row">
                <span class="item-list__name">{{ item.name }}</span>
                <span class="item-list__status">{{
                  storageStatusLabel(item.status)
                }}</span>
              </li>
              }
            </ul>
            }
          </div>
        </li>
        }
      </ul>
    </section>
    }

    @if (data.standalone_items.length > 0) {
    <section class="section">
      <h2 class="section__title">
        {{ 'admin.warehouseCell.standaloneSection' | translate }}
      </h2>
      <ul class="occupant-list">
        @for (occupant of data.standalone_items; track occupant.item.id) {
        <li class="occupant-card">
          <div class="occupant-card__head">
            <h3 class="occupant-card__title">{{ occupant.item.name }}</h3>
            <p class="occupant-card__id mono">{{ occupant.item.id }}</p>
          </div>
          <dl class="kv">
            <dt>{{ 'admin.warehouseCell.status' | translate }}</dt>
            <dd>{{ storageStatusLabel(occupant.item.status) }}</dd>
            <dt>{{ 'admin.warehouseCell.owner' | translate }}</dt>
            <dd>
              <a
                class="owner-link"
                [routerLink]="ownerProfileLink(occupant.owner.user_id)"
              >
                {{ ownerContactLine(occupant.owner) }}
              </a>
            </dd>
          </dl>
        </li>
        }
      </ul>
    </section>
    }
    }
  </div>
  }
</div>
